import { Typography } from '@mui/material'
import { createStyles, makeStyles } from '@mui/styles'
import React, { Fragment } from 'react'

interface ListElementTextProps {
  title: string // values' label
  text: string | number | JSX.Element // value
  center?: boolean
}

const useStyles = makeStyles(() =>
  createStyles({
    title: {
      fontWeight: 'bold'
    },
    text: {
      padding: 0,
      margin: 0
    },
    centerListElementText: {
      textAlign: 'center'
    }
  })
)

export const ListElementText: React.FC<ListElementTextProps> = ({
  title,
  text,
  center = false
}) => {
  const classes = useStyles()
  return (
    <Fragment>
      <Typography
        className={`${classes.title} ${classes.text} ${
          center && classes.centerListElementText
        }`}
        variant='body2'
        component='p'
      >
        {title}
      </Typography>
      <Typography
        className={`${classes.text} ${center && classes.centerListElementText}`}
        variant='body2'
        component='p'
      >
        {text}
      </Typography>
    </Fragment>
  )
}
